import { createEffect, createSignal, onCleanup } from "solid-js";

export function AnimatedNumber(props: { value: number; digits: number; large?: boolean }) {
  const [display, setDisplay] = createSignal(props.value);
  let raf: number | null = null;
  let from = props.value;
  let to = props.value;
  let start = 0;
  const DURATION = 600;

  createEffect(() => {
    to = props.value;
    from = display();
    start = performance.now();
    if (raf) cancelAnimationFrame(raf);
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / DURATION);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(from + (to - from) * eased);
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
  });

  onCleanup(() => {
    if (raf) cancelAnimationFrame(raf);
  });

  const sizeClass = () =>
    props.large
      ? "text-3xl font-black tracking-tight"
      : "text-xl font-bold tracking-tight";

  return (
    <span
      class={`font-display text-[var(--color-text-primary)] text-glow-info ${sizeClass()}`}
      data-numeric
    >
      {display().toFixed(props.digits)}
    </span>
  );
}
